import {React,useRef} from 'react'
import emailjs from '@emailjs/browser';
import Email from './Images/mailW.png'
import Location from './Images/LocationW.png'
import insta from './Images/instaW.png'
import fb from './Images/fbW.png'
import Linkedin from './Images/LinkedinW.png'


export default function Contact() {

  const form=useRef()
  
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_079kuqn', 'template_lze075i', form.current, 'fuKAyZxSFbvDkOlq4')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      }
      );
      
      e.target.reset();
    };
  return (
    <div>
      <section>
        <div id="Contact" className='ContactMain'>
          <div className='ContactTitle'>
          <h2>Contact Us</h2>
          <br/>
          </div>
          <div className='contactCard'>
            
           <table >  
            <td className='contactAddress'>
              <h3><img  src={Email} height={35} width={45}/> Email</h3>
              adityaraj152002@gmail.com
              <br/><br/>
              <h3><img  src={Location} height={35} width={30}/> Address</h3>
              Pune,Maharashtra

              <br/><br/><br/><br/><br/><br/>
              <a href="https://instagram.com/adii152002" target="blank" ><img align="center" src={insta} alt="adii152002" height="35" width="35" /> </a>
              <a href="https://www.facebook.com/adityaraj.patil.792/" target="blank" ><img align="center" src={fb} alt="adii152002" height="30" width="30" /> </a>
              <a href="https://www.linkedin.com/in/adityaraj-patil-a5549727b/" target="blank" ><img align="center" src={Linkedin} alt="adityaraj patil" height="35" width="35" /> </a><br/><br/>
            </td>
            <td>
          <form ref={form} onSubmit={sendEmail} className='contactForm'>
            <table>
            <tr>
            <td>
            Name: <input className='contactContent' type='text' placeholder='Enter Full Name' name="user_name" required/><br/><br/>
            </td>
            </tr>
            <tr>
            <td>
              Email
            <input  className='contactContent' type='text' placeholder='Email' name="user_email" required/><br/><br/>
            </td>
            </tr>
            <tr>
            <td>
              subject
            <input  className='contactContent' type='text' placeholder='Subject' name="subject" required/><br/><br/>
            </td>
            </tr>
            <tr>
            <td>
              message
            <textarea  className='contactContent' name='message' cols={30} rows={5}></textarea><br/>
            </td>
            </tr>
            <button type='submit' class="btn btn-primary">Send message</button>

            </table>
          </form>
          </td>
          </table> 
          
          </div>
          <br/><br/>
        </div>
      </section>
      
    </div>
  )
}
